const BoardPupupCheck = ({ title = '팝업으로 게시', checked, disabled, onChecked }) => {
    return (
        <div className='form-box form-box-checkbox'>
            <div className='input-box'>
                <div className='input-group'>
                    <input
                        type='checkbox'
                        id={title}
                        className='form-control form-control-s'
                        checked={checked}
                        disabled={disabled}
                        onChange={(e) => onChecked(e)}
                    />
                    <label htmlFor={title} className='check-label'>
                        <span>{title}</span>
                    </label>
                </div>
            </div>
        </div>
    );
};

export default BoardPupupCheck;
